export default __webpack_public_path__ + "bc50480f5b3dad4fa8ddd95b3620a680.png";